import { useEffect } from "react";
import api from "@/lib/api";

/** Fire-and-forget internal page-view tracking for the SEO Hub. */
export function useTrackView(type, slug) {
  useEffect(() => {
    if (!type || !slug) return;
    api.post("/track/view", { type, slug }).catch(() => {});
  }, [type, slug]);
}
